export default __webpack_public_path__ + "static/media/snehal-pic-2.11733052.png";